import { render } from "./VentasDetalle.vue?vue&type=template&id=3fb901cc&scoped=true"
import script from "./VentasDetalle.vue?vue&type=script&lang=js"
export * from "./VentasDetalle.vue?vue&type=script&lang=js"

import "./VentasDetalle.vue?vue&type=style&index=0&id=3fb901cc&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb901cc"]])

export default __exports__